import { getFormattedDecimalValue } from "@components/Amount";

type SubInvestment = {
  amount: number;
};

type Investment = {
  investments?: SubInvestment[];
};

const computeInvestmentAmount = (investment: Investment): number => {
  const { investments = [] } = investment;

  const totalAmount = investments
    .map(({ amount }) => amount)
    .reduce((total, amount) => getFormattedDecimalValue(total, amount, "plus"), 0);

  return totalAmount;
};

export default computeInvestmentAmount;
